import { Suspense, lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { Grid } from "@mui/material";
const Login = lazy(()=> import("./Components/Login/Login"));
const ProtectedRoute = lazy(() => import("./Components/Utils/ProtectedRoute"));
const Dashboard = lazy(() => import("../src/Components/Dashboard/Dashboard"));
const PermissionList = lazy(()=>import("./Features/PermissionManagement/permissionList"));
const AddEditPermission = lazy(()=>import("./Features/PermissionManagement/AddEditPermission"));
const RoleList = lazy(()=> import("./Features/RoleManagement/Role"));
const Configuration = lazy(() => import("./Features/Configuration/Configuration"));
const TestPermissions=lazy(()=>import('../src/Components/TestPermission'))
const RoleDetails = lazy(() =>
  import("./Features/RoleManagement/RoleDetails")
);

const Permission = lazy(() =>
  import("./Features/PermissionManagement/Permissions/Permission")
);
const CreateRoles = lazy(()=>import('./Components/Create_Role/CreateRole'));
const StateManagement = lazy(()=>import('../src/Components/StateManagment/index'))
const errorImage =require('../src/img/error.jpg')
const ERROR = () => {
  return (
    <Grid container>
      <Grid item lg={12} xs={12} md={12} container justifyContent="center" >
        <img
          src={errorImage}
          alt="error_image"
          style={{ width: "100vw", height: "100vh" }}
        />
      </Grid>
    </Grid>
  );
};
function App() {



  if(false){console.log = function () {}}
  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<ERROR/>} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/testPermissions" element={<TestPermissions />} />
          <Route path="/permission-group" element={<PermissionList />} />
          <Route path="/permissions" element={<Permission />} />
          <Route path="/createRoles" element={<CreateRoles />} />
          <Route path="/addEditPermission" element={<AddEditPermission />} />
          <Route path="/user-roles" element={<Configuration />} />
          <Route path="/roles" element={<RoleList />} />
          <Route path="/stateManagement" element={<StateManagement />} />
          <Route path="/role-details" element={<RoleDetails />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;